import {
    createStyles,
    WithStyles,
    withStyles,
    WithTheme,
} from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { PageHeader, PageType } from ".";
import { Loading, RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "stretch",
            flexGrow: 1,
            borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        },
        pageHeader: {},
        pageContent: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            alignItems: "stretch",
        },
        pagePrimary: {
            backgroundColor: theme.relode.colors.pagePrimaryBackground,
        },
        pageSecondary: {
            backgroundColor: theme.relode.colors.pageSecondaryBackground,
        },
    });

interface Props extends WithStyles<typeof styles>, WithTheme {
    id: string;
    children?: React.ReactNode;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    className?: string;
    label?: string;
    labelLinkURL?: string;
    statusLabel?: React.ReactNode;
    pageTitle?: string;
    isBusy?: boolean;
    actions?: React.ReactNode;
    headerInfo?: React.ReactNode;
    backUrl?: string;
    busyType?: "bar" | "overlay" | "both";
    pageType?: PageType;
    showHeaderShadow?: boolean;
    showHeader?: boolean;
}

export const Page = withStyles(styles, { name: "Page", withTheme: true })(
    (props: Props) => {
        const {
            id,
            children,
            title,
            subtitle,
            classes,
            className: classNameProp,
            label,
            labelLinkURL,
            statusLabel,
            pageTitle,
            actions,
            headerInfo,
            isBusy = false,
            backUrl,
            busyType = "both",
            pageType = "primary",
            showHeaderShadow = false,
            showHeader = true,
            ...other
        } = props;

        const rootClass = classnames(
            {
                [classes.root]: true,
                [classes.pagePrimary]: pageType === "primary",
                [classes.pageSecondary]: pageType === "secondary",
            },
            classNameProp
        );

        return (
            <div id={id} className={rootClass} {...other}>
                {showHeader === true ? (
                    <PageHeader
                        label={label}
                        labelLinkURL={labelLinkURL}
                        statusLabel={statusLabel}
                        isBusy={isBusy && busyType !== "overlay"}
                        backUrl={backUrl}
                        pageType={pageType}
                        headerInfo={headerInfo}
                        title={title}
                        subtitle={subtitle}
                        pageTitle={pageTitle}
                        showHeaderShadow={showHeaderShadow}
                    >
                        {actions}
                    </PageHeader>
                ) : null}
                <Loading
                    isLoading={isBusy && busyType !== "bar"}
                    variant="blur"
                    showIndicator={busyType !== "bar"}
                    fillSpace
                >
                    <div className={classes.pageContent}>{children}</div>
                </Loading>
            </div>
        );
    }
);

// Set default props
Page.defaultProps = {
    isBusy: false,
};
